// Multi-project incremental redemption options for development support.
// Purchasable blocks and redeemable amounts share one grid (HOUR_GRID_STEP), so any block
// a user buys can be allocated in the same units it was sold in. Below the engagement
// floor nothing is offered — an engagement needs ENGAGEMENT_MIN_HOURS to open.
// Options are capped to the purchasable presets plus an "all remaining" amount so a large
// balance doesn't render dozens of pills. The server still caps any redemption at the
// user's available balance.

import {
  ENGAGEMENT_MIN_HOURS,
  HOUR_GRID_STEP,
  HOUR_PACKAGES,
} from "./expertHours";

export const REDEMPTION_STEP = HOUR_GRID_STEP;
export const REDEMPTION_MINIMUM = ENGAGEMENT_MIN_HOURS;

export function computeRedemptionOptions(available: number): number[] {
  const a = Math.floor(available);
  if (a < REDEMPTION_MINIMUM) return [];

  // Preset blocks the balance can cover, so the redeem units mirror the purchase units.
  const opts = HOUR_PACKAGES.map((p) => p.hours).filter((h) => h <= a);

  // Offer the exact balance too when it isn't already a preset, so hours never get stranded.
  if (!opts.includes(a)) opts.push(a);

  return opts.sort((x, y) => x - y);
}
